import Card from "@/UI/Card";
import Table from "@/UI/Table";
import { Tag, Tooltip } from "antd";
import { Link } from "react-router-dom";
import UserPrivateComponent from "../PrivacyComponent/UserPrivateComponent";
import BigDrawer from "../Drawer/BigDrawer";
import CreateTicket from "../CRM/Ticket/CreateTicket";
import { useTranslation } from "react-i18next";

import { useEffect } from "react";
import { useDispatch } from "react-redux";

export default function SingleContactTicket({
  data,
  loading,
  name,
  singleLoadThunk,
  contactId,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (contactId && singleLoadThunk) {
      dispatch(singleLoadThunk({ contactId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactId]);

  const columns = [
    {
      title: "ID",
      key: "ticketId",
      dataIndex: "ticketId",
      render: (ticketId) => (
        <Link to={`/admin/ticket/${ticketId}`}>{ticketId}</Link>
      ),
      renderCsv: (ticketId) => ticketId,
    },

    {
      title: "Subject",
      key: "subject",
      dataIndex: "subject",
    },
    {
      title: t("common.status"),
      key: "ticketStatusName",
      render: (record) => (
        <Tag color="orange">{record.ticketStatusName || "-"}</Tag>
      ),
      renderCsv: (record) => record.status || record.ticketStatusName,
    },
    // {
    //   title: "Action",
    //   dataIndex: "ticketId",
    //   key: "action",
    //   render: (ticketId) => (
    //     <div className='flex justify-start'>
    //       <ViewBtn path={`/support/ticket/${ticketId}`} />
    //     </div>
    //   ),
    // },
  ];
  return (
    <Card
      className="border-none"
      title={
        <div className="flex items-center justify-between w-full">
          <span className="font-bold">Tickets</span>
          <BigDrawer
            title={"Ticket"}
            btnTitle={t("ticket.addTicket") || "Add Ticket"}
            onClose={() => singleLoadThunk && singleLoadThunk({ [name]: contactId })}>
            <CreateTicket customerId={contactId} />
          </BigDrawer>
        </div>
      }
      bodyStyle={{ padding: 0 }}>
      <div>
        <UserPrivateComponent permission="readAll-ticket">
          <Table
            bordered
            columns={columns}
            loading={loading}
            data={data || []}
          />
        </UserPrivateComponent>
      </div>
    </Card>
  );
}
